import { useTypedSelector } from "../hooks";
import { reduxStore } from "../reduxStore";
import {
  ToastItem,
  ToastTypeError,
  ToastTypeInfo,
  toastSlice,
} from "../slices/toastSlice";

export const useToasts = (): ToastItem[] => {
  const state = useTypedSelector(({ toast }) => toast);
  return Object.values(state);
};

export const pushError = (error: Error): void => {
  const payload: ToastItem = {
    message: error.message,
    ts: Date.now(),
    type: ToastTypeError,
  };
  const action = toastSlice.actions.set(payload);
  reduxStore.dispatch(action);
};

export const pushNotification = (
  payload: Omit<ToastItem, "ts" | "type">
): void => {
  const action = toastSlice.actions.set({
    ...payload,
    ts: Date.now(),
    type: ToastTypeInfo,
  });
  reduxStore.dispatch(action);
};
